import {Button, Slider} from "antd";
import {useEffect, useState} from "react";
import {PauseCircleOutlined, PlayCircleOutlined} from "@ant-design/icons";
import dayjs from "dayjs";


const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

export function SingleLayerTime({
                                    id,
                                    dataTime,
                                    timeSelectedIdx,
                                    setTimeSelectedIdx,
                                }) {
    const formatter = (value) => dayjs(dataTime[value]?.date, "DD-MM-YYYY").format('MMMM, YYYY')
    const [value, setValue] = useState(0);
    const [isRunning, setIsRunning] = useState(false);
    const [isRunningId, setIsRunningId] = useState(0);
    const styleBtn = {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: '5px',
        paddingRight: '12px',
        display: 'flex',
        alignItems: 'center'
    }
    const styleIcon = {
        color: '#5256be',
        fontSize: '1.6em'
    }

    function changeValue(value) {
        setValue(value)
        setTimeSelectedIdx(value)
    }

    function timerRun() {
        setIsRunning(true)

        const id = setInterval(() => {

            setValue(pre => (pre === dataTime.length) ? 0 : pre + 1)
            setTimeSelectedIdx(pre => (pre === dataTime.length) ? 0 : pre + 1)

        }, 1500, value)

        setIsRunningId(id)
    }

    function timerStop() {
        clearInterval(isRunningId)
        setIsRunningId(0)
        setIsRunning(false)
    }

    useEffect(() => {
        setValue(timeSelectedIdx)
    }, [timeSelectedIdx]);

    useEffect(() => {
        timerStop()
    }, [id]);

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
        }}>

            {!isRunning && <Button
                onClick={timerRun}
                type="link"
                style={styleBtn}><PlayCircleOutlined style={styleIcon}/></Button>}
            {isRunning && <Button
                onClick={timerStop}
                type="link"
                style={styleBtn}><PauseCircleOutlined style={styleIcon}/></Button>}
            <div>
                <Slider
                    style={{width: 400}}
                    value={value}
                    min={0}
                    max={dataTime.length - 1}
                    onChange={(event) => setValue(event)}
                    onAfterChange={changeValue}
                    tooltip={{
                        formatter,
                        open:true
                    }}
                />
            </div>
        </div>
    )
}